//@flow
import * as React from "react";
import styled from "react-emotion";
import WorkGridItem from "../WorkGridItem";
import { black } from "../../styles/colors";
import { theme, mqMin } from "../../styles/theme";
import ScrollNotifier from "../ScrollNotifier";

const ProcessGrid = styled.section`
  position: relative;
  margin: 0 auto;
  padding-left: ${theme.space1};
  padding-right: ${theme.space1};
  padding-top: ${theme.space4};
  padding-bottom: ${theme.space4};
  color: ${black};
  max-width: ${theme.maxWidth3};
`;

const workEdgeToProps = edge => {
  return {
    text: edge.node.data.work_list_title,
    heading: edge.node.data.client_name,
    meta: edge.node.data.type_of_work,
    uid: `/article/${edge.node.uid}`
  };
};

export default ({ workItems }) => {
  return (
    <ProcessGrid>
      <ScrollNotifier offset="0%" onEnter="FOOTER" />
      {workItems.filter(x => !x.node.tags.includes("landing")).map((w, k) => (
        <div key={k}>
          {console.log(w)}
          <WorkGridItem {...workEdgeToProps(w)} />
          <ScrollNotifier
            offset="0%"
            onEnter={k % 2 === 0 ? `WORK_${k}` : null}
          />
        </div>
      ))}
    </ProcessGrid>
  );
};



// WEBPACK FOOTER //
// ./src/components/WorkGrid/index.js